import { http } from '../utils/axios';
import {
  IExternalPharmacy,
  IResponseSetExternalPharmacy,
  ISearchAvailablePharmacies,
  ISetPharmacy
} from 'shared/interfaces/pharmacy.interface';

class PharmaciesService {
  private static instance: PharmaciesService;

  // eslint-disable-next-line @typescript-eslint/no-empty-function
  private constructor() {}

  static getInstance(): PharmaciesService {
    if (!PharmaciesService.instance) {
      PharmaciesService.instance = new PharmaciesService();
    }

    return PharmaciesService.instance;
  }

  getAvailablePharmacies = async (payload: ISearchAvailablePharmacies) => {
    const { data } = await http<IExternalPharmacy[]>({
      method: 'GET',
      url: '/pharmacy/actions/getAvailablePharmacies',
      params: payload
    });
    return data;
  };

  setPharmacy = async (payload: ISetPharmacy) => {
    const { data } = await http<IResponseSetExternalPharmacy>({
      method: 'POST',
      url: '/pharmacy/actions/setPharmacy',
      data: payload
    });
    return data;
  };
}

const instance = PharmaciesService.getInstance();

export default instance;
